<form novalidate #propertySaleAttributeSectionForm="ngForm">
    <div class="property-sale-attribute-section__amenities">
        <tg-input-container
            class="property-sale-attribute-section__amenities-input"
            label="Amenities in this area"
            showRemainingCharacters="false"
        >
            <textarea
                tgTextInput
                ngModel
                name="amenities"
                rows="3"
                [validation]="
                    validation.propertyDescription.amenities | toValidator
                "
                placeholder="What's nearby? Shops, parks, motorway access etc."
                (blur)="publish()"
                [(ngModel)]="draftData.propertyDescription.amenities"
            ></textarea>
        </tg-input-container>
        <p class="property-sale-attribute-section__amenities-text">
            Note: Nearby schools and zoning will automatically be included based
            on the property's address
        </p>
    </div>
</form>
